import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  { heading: 'Sales' },
  {
    page: PageMeta.Quotes.List,
    title: 'Quotes',
    icon: { icon: PageMeta.Quotes.List.Icon },
    to: PageMeta.Quotes.List.Name,
  },
  {
    page: PageMeta.Invoices.List,
    title: 'Invoices',
    icon: { icon: PageMeta.Invoices.List.Icon },
    to: PageMeta.Invoices.List.Name,
  },

  /*
  {
    title: 'Contracts',
    icon: { icon: 'tabler-contract' },
    to: 'apps-contracts-list',
  },*/
]
